module.exports = __webpack_public_path__ + "img/banner-1.9af40c6b.png";